import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8e3a7370&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=8e3a7370&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3a7370",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e3a7370')) {
      api.createRecord('8e3a7370', component.options)
    } else {
      api.reload('8e3a7370', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8e3a7370&scoped=true&", function () {
      api.rerender('8e3a7370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ScrollPane/index.vue"
export default component.exports